/**
 * Filtra os dados de pacientes do CAPS
 *
 * @param {Array} cadastros
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @param {Object|null} selectedFilterVulnerabilidade
 * @returns {Array}
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedFilterVulnerabilidade
) {
  let cadastros_filtrados = Array.isArray(cadastros) ? cadastros : []

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      return (
        item.is_em_dia == null ||
        item.is_em_dia == '0' ||
        item.is_em_dia === 0 ||
        item.is_faltoso == '1' ||
        item.is_faltoso === 1
      )
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      return (
        (item.is_em_dia != null && (item.is_em_dia == '1' || item.is_em_dia === 1)) ||
        (item.is_faltoso != null && (item.is_faltoso == '0' || item.is_faltoso === 0))
      )
    })
  }

  if (
    selectedFilterVulnerabilidade != null &&
    Array.isArray(selectedFilterVulnerabilidade.valuesToSearch) &&
    selectedFilterVulnerabilidade.valuesToSearch.length > 0
  ) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (!item.vulnerabilidade) {
        return false
      }

      let vulnerabilidades = []

      try {
        if (typeof item.vulnerabilidade === 'string') {
          vulnerabilidades = JSON.parse(item.vulnerabilidade)
        } else if (Array.isArray(item.vulnerabilidade)) {
          vulnerabilidades = item.vulnerabilidade
        }
      } catch (error) {
        vulnerabilidades = [item.vulnerabilidade]
      }

      const valoresBusca = selectedFilterVulnerabilidade.valuesToSearch.map(
        (v) => String(v).toLowerCase()
      )

      return vulnerabilidades.some((v) =>
        valoresBusca.includes(String(v).toLowerCase())
      )
    })
  }

  return cadastros_filtrados
}
